export enum AchievementTypesEnum {
	Medal = '1ac62836-08cb-46de-a55e-c0832f40a870',
	Trophy = '09474b94-363e-4e8c-bd1c-a71640ee7b39',
}
